function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6157 9.25995C33.9868 9.25995 44.5423 1.29773 51.949 1.29773C59.3557 1.29773 74.9112 5.55551 74.9112 39.6289C74.9112 73.7022 53.9845 78.7022 45.8379 78.7022C7.68899 78.7044 -8.60657 9.25995 18.6157 9.25995Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.4021 55.6289L25.871 63.72C24.9888 64.2467 23.9066 63.46 24.1332 62.4556L27.6288 47.0556C27.7243 46.6356 27.5821 46.1978 27.2599 45.9156L15.3999 35.5156C14.6266 34.8378 15.0399 33.5622 16.0643 33.4689L31.7577 32.0422C32.1843 32.0044 32.5577 31.7333 32.7266 31.3378L38.9288 16.82C39.3332 15.8733 40.671 15.8733 41.0754 16.82L47.2777 31.3378C47.4465 31.7333 47.8177 32.0044 48.2466 32.0422L63.9399 33.4689C64.9621 33.5622 65.3754 34.8378 64.6043 35.5156L52.7443 45.9133C52.4221 46.1956 52.2799 46.6356 52.3754 47.0533L55.871 62.4533C56.0999 63.4578 55.0154 64.2444 54.1332 63.7178L40.6021 55.6267C40.2288 55.4089 39.771 55.4089 39.4021 55.6289Z",
  fill: "#E7F5FE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.6287 47.0555C32.7243 46.6355 32.5821 46.1978 32.2599 45.9156L20.3998 35.5155C19.6265 34.8378 20.0398 33.5622 21.0643 33.4689L36.1821 33.3333C36.6087 33.2955 36.9821 33.0244 37.151 32.6289L42.4999 20.16L41.0732 16.82C40.6688 15.8733 39.331 15.8733 38.9265 16.82L32.7243 31.3378C32.5554 31.7333 32.1843 32.0044 31.7554 32.0422L16.0621 33.4689C15.0398 33.5622 14.6265 34.8378 15.3976 35.5155L27.2576 45.9133C27.5799 46.1955 27.7221 46.6355 27.6265 47.0533L24.131 62.4533C23.9021 63.4578 24.9865 64.2444 25.8687 63.7178L29.3132 61.6578L32.6287 47.0555Z",
  fill: "#B6E2FB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M45.5978 55.6289C45.2289 55.4089 44.7689 55.4089 44.4022 55.6289L42.5 56.7666L54.1289 63.7222C55.0111 64.2489 56.0933 63.4622 55.8667 62.4577L55.6867 61.6622L45.5978 55.6289Z",
  fill: "#B6E2FB"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.94864 10.8044L10.52 9.23309L13.6627 12.3758L12.0913 13.9471L8.94864 10.8044Z",
  fill: "#A4AFC1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.981 19.8392L19.5523 18.2679L22.695 21.4106L21.1237 22.9819L17.981 19.8392Z",
  fill: "#A4AFC1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.55637 21.4128L11.6991 18.2701L13.2704 19.8415L10.1277 22.9842L8.55637 21.4128Z",
  fill: "#A4AFC1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5882 12.3804L20.7309 9.23768L22.3022 10.809L19.1595 13.9517L17.5882 12.3804Z",
  fill: "#A4AFC1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M68.6024 26.6667C66.7646 26.6667 65.269 25.1711 65.269 23.3333C65.269 21.4956 66.7646 20 68.6024 20C70.4402 20 71.9357 21.4956 71.9357 23.3333C71.9357 25.1711 70.4402 26.6667 68.6024 26.6667ZM68.6024 22.2222C67.9913 22.2222 67.4913 22.72 67.4913 23.3333C67.4913 23.9467 67.9913 24.4444 68.6024 24.4444C69.2135 24.4444 69.7135 23.9467 69.7135 23.3333C69.7135 22.72 69.2135 22.2222 68.6024 22.2222Z",
  fill: "#A4AFC1"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2712 65.5533C24.6867 65.5533 24.1067 65.3711 23.6112 65.0133C22.689 64.3444 22.2579 63.1956 22.509 62.0867L25.9401 46.9733L14.3045 36.7689C13.449 36.0222 13.1245 34.8378 13.4756 33.7578C13.8245 32.6778 14.7823 31.9111 15.9134 31.8089L31.309 30.4111L37.3956 16.1667C37.8423 15.12 38.8645 14.4445 40.0001 14.4445C41.1356 14.4445 42.1579 15.12 42.6067 16.1645L48.6934 30.4111L51.2601 30.6445L50.9601 33.9645L48.0934 33.7045C47.0467 33.6089 46.1467 32.9511 45.7379 31.9867L40.0001 18.5489L34.2556 31.9933C33.8512 32.9511 32.9512 33.6089 31.9067 33.7045L17.369 35.0245L28.3556 44.66C29.1423 45.3489 29.4867 46.4067 29.2534 47.4244L26.0156 61.6889L38.5445 54.1978C39.4423 53.6622 40.5534 53.6622 41.4534 54.1978L53.9823 61.6911L50.7445 47.4267C50.5134 46.4111 50.8578 45.3511 51.6423 44.6645L62.629 35.0289L55.4023 34.3733L55.7067 31.0533L64.0867 31.8156C65.2178 31.9178 66.1734 32.6845 66.5245 33.7645C66.8756 34.8445 66.5512 36.0289 65.6956 36.7756L54.0601 46.9778L57.4912 62.0911C57.7423 63.2022 57.3112 64.3511 56.389 65.0178C55.469 65.6844 54.2423 65.7356 53.2734 65.1533L40.0001 57.2133L26.7245 65.1511C26.2756 65.4178 25.7756 65.5533 25.2712 65.5533ZM31.189 30.6867C31.189 30.6867 31.189 30.6889 31.1867 30.6911L31.189 30.6867ZM48.8067 30.68L48.809 30.6845C48.809 30.6822 48.809 30.6822 48.8067 30.68Z",
  fill: "#75768A"
});

function SvgFavourite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/favourite.a1adda2d.svg";
export { ForwardRef as ReactComponent };